















import { Vue, Component, Prop } from "vue-property-decorator";

import { ExportStage } from "../data/ChatExportDataLoader";
import ChatExportStage from "./ChatExportStage.vue";
import TableOfContents, { TableOfContentsModel } from "./TableOfContents.vue";
import { Room } from "../../chat/models/Rooms/Room";
import { Element } from "../../../api/models/Element";

@Component({
    components: { ChatExportStage, TableOfContents }
})
export default class ExportPreview extends Vue {
    @Prop({ required: true, default: [] }) stages: ExportStage[];
    @Prop({ required: true, default: [] }) rooms: Room[];

    get tableOfContents(): TableOfContentsModel[] {
        return this.stages.map((stage) => {
            return {
                title: stage.title,
                id: stage.roomId
            }
        })
    }

    get ownName() {
        const { firstName, lastName } = this.$store.state.session.profile;
        return  firstName && lastName ? `${firstName} ${lastName}` : firstName ? firstName : lastName;
    }

    get currentEventName(): string | undefined | null {
        const id: string = this.$store.state.events.selected;
        const list: Element[] = this.$store.state.events.list;
        return list.find((event: Element) => event.id === id)?.title;
    }
}
